export default __webpack_public_path__ + "static/media/crown-noBg.b9b4c7f2.svg";